import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { blogList, categoryList } from '../../api/apiHandler';
import moment from 'moment/moment';
import { encryption } from '../../common/enc_dec';
import { useTranslation } from 'react-i18next';
import '../../i18';

const Footer = () => {
    const { t } = useTranslation();
    const [blogs, setBlogs] = useState([]);
    const [categories, setCategories] = useState([]);

    const isLoggedIn = useSelector((state) => state.auth.userToken);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await blogList({
                    limit: 2
                });
                if (response.code === 200 || response.code === 404) {
                    setBlogs(response.data);
                }
            }
            catch (err) {
                console.log('err: ', err);
            }
        }
        fetchBlogs();
    }, [])

    useEffect(() => {
        categoryList({
            limit: 5
        })
            .then(response => {
                if (response.code === 200) {
                    setCategories(response.data.data);
                }
                else {
                    setCategories([]);
                }
            })
    }, []);

    return (
        <>
            <footer className="footer-area bg-gray">
                <div className="footer-top">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-md-12">
                                <div className="widget widget_contact">
                                    <h4 className="widget-title">{t('contactUsHeading')}</h4>
                                    <ul className="details">
                                        <li>
                                            <i className="fa fa-map-marker" /> {t('address')}
                                            <p>{t('address1')}</p>
                                        </li>
                                        <li>
                                            <i className="fa fa-envelope" /> {t('contactEmail')}
                                        </li>
                                        <li>
                                            <i className="fa fa-phone" /> {t('contactNo')}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-12">
                                <div className="widget widget_nav_menu">
                                    <h4 className="widget-title">{t('courseHeading')}</h4>
                                    <ul>
                                        {categories && categories?.length > 0 && categories?.map(category => (

                                            <li key={category?.id}>
                                                <Link
                                                    to={isLoggedIn ? '/home' : '/'}
                                                    state={{ selectedCategoryId: category.id }}
                                                >
                                                    {category.name}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-12">
                                <div className="widget widget_blog_list">
                                    <h4 className="widget-title">{t('newsNBlog')}</h4>
                                    <ul>
                                        {blogs && blogs?.data && blogs?.data?.length > 0 && blogs?.data?.map(blog => (
                                            <li key={blog?.id}>
                                                <h6>
                                                    <Link to={`/blog-details/${encodeURIComponent(encryption({ blog_id: blog.id }, true))}`}>
                                                        {blog?.title}
                                                    </Link>
                                                </h6>
                                                <span className="date">
                                                    <i className="fa fa-calendar" />
                                                    {moment(blog?.blog_date).format('MMMM D, YYYY')}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="widget widget_nav_menu">
                                    <h4 className="widget-title">{t('Pages')}</h4>
                                    <ul className="details">
                                        <li>
                                            <Link to="/about-us">{t('aboutUs')}</Link>
                                        </li>
                                        <li>
                                            <Link to="/faq">{t('faq')}</Link>
                                        </li>
                                        <li>
                                            <Link to="/tandc">{t('TnC')}</Link>
                                        </li>
                                        <li>
                                            <Link to="/privacy-policy">{t('privacyPolicy')}</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 align-self-center">
                                <div className="FooterOne">
                                    <Link to={`${isLoggedIn ? '/home' : '/'}`} className="HeaderLogoLink">
                                        <img src={process.env.PUBLIC_URL + "/assets/img/logo-new.svg"} alt="img" />
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-4  col-md-6 order-lg-12 text-md-right align-self-center">
                                <ul className="social-media mt-md-0 mt-3">
                                <li>
                                        <a className="linkedin" href="https://in.linkedin.com" target="_blank" rel="noopener noreferrer">
                                            <i className="fa fa-linkedin" />
                                        </a>
                                    </li>
                                    <li>
                                        <a className="twitter" href="https://www.twitter.com" target="_blank" rel="noopener noreferrer">
                                            <i className="fa fa-twitter" />
                                        </a>
                                    </li>
                                    {/* <li>
                                        <a className="instagram" href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
                                            <i className="fa fa-instagram" />
                                        </a>
                                    </li> */}
                                    <li>
                                        <a className="youtube" href="https://www.youtube.com" target="_blank" rel="noopener noreferrer">
                                            <i className="fa fa-youtube" />
                                        </a>
                                    </li>
                                    {/* <li>
                                        <a className="pinterest" href="https://www.pinterest.com" target="_blank" rel="noopener noreferrer">
                                            <i className="fa fa-pinterest" />
                                        </a>
                                    </li> */}
                                </ul>
                            </div>
                            <div className="col-lg-4 order-lg-8 text-lg-center align-self-center mt-lg-0 mt-3">
                                <p>&copy; {new Date().getFullYear()} lea.training All rights reserved.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer;